import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { UserContext } from "@/components/User";
import { WizardConfig } from "@/components/wizards/WizardConfig";
import { IJobApplication } from "@/data/job-applications";
import { JobApplicationStep } from "@/data/job-applications/types/JobApplicationStep";
import { mapJobApplicationStepKey } from "@/data/job-applications/utils/mapJobApplicationStepKey";
import { JobRequest } from "@/data/job-requests/types/JobRequest";

export const useApplyWizardConfig = (jobRequest: JobRequest, initialDraft?: IJobApplication): WizardConfig => {
  const { t } = useTranslation("session");

  const { hasCompanyManagerPrivileges } = useContext(UserContext);

  return {
    steps: [
      {
        step: mapJobApplicationStepKey["CANDIDATE"],
        label: t("JOB_REQUESTS.APPLY.WIZARD.CANDIDATE"),
        key: "CANDIDATE",
        enabled: hasCompanyManagerPrivileges(),
      },
      {
        step: mapJobApplicationStepKey["DETAILS"],
        label: t("JOB_REQUESTS.APPLY.WIZARD.DETAILS"),
        key: "DETAILS",
      },
      {
        step: mapJobApplicationStepKey["FILES"],
        label: t("JOB_REQUESTS.APPLY.WIZARD.FILES"),
        key: "FILES",
      },
      {
        step: mapJobApplicationStepKey["QUESTIONNAIRE"],
        label: t("JOB_REQUESTS.APPLY.WIZARD.QUESTIONNAIRE"),
        enabled: Boolean(jobRequest.questions?.length),
        key: "QUESTIONNAIRE",
      },
      {
        step: mapJobApplicationStepKey["WORKSTYLES"],
        label: t("JOB_REQUESTS.APPLY.WIZARD.WORKSTYLES"),
        enabled: Boolean(jobRequest.workStyles?.length),
        key: "WORKSTYLES",
      },
      {
        step: mapJobApplicationStepKey["SUMMARY"],
        label: t("JOB_REQUESTS.APPLY.WIZARD.SUMMARY"),
        key: "SUMMARY",
      },
    ],
    initialStep: initialDraft ? JobApplicationStep.DETAILS : JobApplicationStep.CANDIDATE,
  };
};
